import { Monster } from '../../lib/interfaces';
import parse from 'html-react-parser';

interface BestiaryProps {
    data: Array<Monster>;
}

export default function Bestiary({ data }: BestiaryProps) {
    return <div className="panel">
        {data.map(monster => <>
            <h2>{monster.name}</h2>
            <b>{monster.stats}</b>
            <p>{parse(monster.description)}</p>
        </>)}
    </div>;
}
